// extracted by mini-css-extract-plugin
module.exports = {"page":"Legal_page__259Ik","content":"Legal_content__opsiN"};